const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
require("./passwordGuidelines.less");

export default function (mainEl) {
    const self = this;
    const current = $('#current');
    const password1 = $('#newpwd');
    const password2 = $('#confirmpwd');
    const uppercaseRequired = $('.one-uppercase-req-checkbox');
    const lowercaseRequired = $('.one-lowercase-req-checkbox');
    const numberRequired = $('.one-number-req-checkbox');
    const minCharRequired = $('.min-characters-req-checkbox');
    const matchRequired = $('.passwords-match-req-checkbox');
    const showPassword = $('.show-password-checkbox');
    const guidelinesList = $('.guidelines-list');
    const updatePasswordSubmitBtn = $('.update-password-submit-btn');
    const passGuidelines = $('.pass-guidelines');
    const passFuncGuidelines = $('.pass-function-guidelines');
    const updatePasswordMainForm = mainEl.find("form[name*='updatefm']" );
    const currentPasswordErrorMsg= mainEl.find(".invalid-current-message");
    const emptyCurrentPwdMsg = mainEl.find('.empty-current-password');
    
    
    self.init = function() {
        bindElements();
        passGuidelines.hide();
        passFuncGuidelines.hide();
    };

    function bindElements() {
        password1.on("keyup", password1Validation);
        password2.on("keyup", password2Validation);
        showPassword.on("change", showPasswordFunc);
        updatePasswordSubmitBtn.on('click', updatePasswordSubmitFunc);
    }

    function password1Validation() {
        let passwordInput = password1.val();
        // Must include at least (1) uppercase character
        if (passwordInput.search(/[A-Z]/) == -1) {
            uppercaseRequired.removeAttr('checked');
        } else {
            uppercaseRequired.attr('checked','checked');
        }
        // Must include at least (1) lowercase character
        if (passwordInput.search(/[a-z]/) == -1) {
            lowercaseRequired.removeAttr('checked');
        } else {
            lowercaseRequired.attr('checked','checked');
        }
        // Must include at least (1) number
        if (passwordInput.search(/\d/) == -1) {
            numberRequired.removeAttr('checked');
        } else {
            numberRequired.attr('checked','checked');
        }
        // Minimum 8 characters
        if (passwordInput.length < 8) {
            minCharRequired.removeAttr('checked');
        } else {
            minCharRequired.attr('checked','checked');
        }
    }

    function password2Validation() {
        // New Password & Confirm Password must match
        if (password1.val() != password2.val()) {
            matchRequired.removeAttr('checked');
        } else {
            matchRequired.attr('checked','checked');
        }
    }

    function showPasswordFunc() {
        if(showPassword.is(":checked")) {
            password1.prop('type','text');
            password2.prop('type','text');
        } else {
            password1.prop('type','password');
            password2.prop('type','password');
        }
    }

    function updatePasswordSubmitFunc(e) {
        e.preventDefault();
        passGuidelines.hide();
        passFuncGuidelines.hide();

        // check password general guidelines
        let validPassword = true;
        $.each(guidelinesList, function(index,value) {
            if(!$(value).is(":checked")) {
                validPassword = false;
            }
        });

        // check password function guidelines
        let validFuncPassword = true;
        let passInput = password1.val();
        let firstName = updatePasswordMainForm.data('first-name');
        let lastName = updatePasswordMainForm.data('last-name');
        let retName = updatePasswordMainForm.data('retailer-name');
        if( passInput.indexOf(firstName) != -1 || passInput.indexOf(lastName) != -1 || (retName != '' && passInput.indexOf(retName) != -1) ) {
            validFuncPassword = false;
        }

        //Check current password is empty 
        let currentPwd = current.val();
        
        if(_.isEmpty(currentPwd)) {
            emptyCurrentPwdMsg.removeClass('hidden');
            currentPasswordErrorMsg.hide();
        } else if(!validPassword) { 
            emptyCurrentPwdMsg.addClass('hidden');
            currentPasswordErrorMsg.hide();
            passGuidelines.show();
        } else if(!validFuncPassword) {
            emptyCurrentPwdMsg.addClass('hidden');
            currentPasswordErrorMsg.hide();
            passFuncGuidelines.show();
        } else {
            emptyCurrentPwdMsg.addClass('hidden');
            currentPasswordErrorMsg.hide();
            updatePasswordMainForm.attr('action', updatePasswordMainForm.data('update-url'));
            updatePasswordMainForm.submit();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/passwordGuidelines/changePasswordLogic.js